module.exports = __webpack_public_path__ + "img/empty-image-default.0bc9958e.png";